module.exports = __webpack_public_path__ + "media/signup-react/sephora-23935e53.png";